<template>
  <custom-callout
    border-color="dark-green"
    class="mb-4 rounded"
    :has-toggle="false"
  >
    <div class="py-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-clipboard-list mb-1"
          icon-background="white"
          icon-color="#2DB782 "
          icon-size="16px"
          title="Cambiar Estatus"
        />
      </div>
      <validation-observer ref="statusCardObserver">
        <div class="row my-3">
          <div class="col-md-4 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.status"
                :clearable="false"
                :custom-error-msg="'El estatus es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Nuevo Estatus:"
                :options="statuses"
                placeholder="Seleccione"
                @input="onStatusChange"
              />
            </validation-provider>
          </div>
          <div v-if="isDeliveredForObligation" class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                v-model="model.poNumber"
                :custom-error-msg="'El Número de PO es requerido.'"
                :error="errors[0]"
                label="Número de PO:"
                type="number"
              />
            </validation-provider>
          </div>
          <div v-if="isDeliveredForObligation" class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                v-model="model.poBalance"
                :custom-error-msg="'El Balance del PO es requerido.'"
                :error="errors[0]"
                label="Balance del PO:"
                mask-type="Money"
                placeholder="0.00"
                type="number"
              />
            </validation-provider>
          </div>
          <div v-else class="col-md-4 px-0">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                v-model="model.comment"
                :custom-error-msg="'El comentario es requerido.'"
                :error="errors[0]"
                label="Comentario:"
                type="text"
              />
            </validation-provider>
          </div>

          <div class="col-md-4 actions-container">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3 pl-3 pr-4"
              @click="onClose"
            />
            <action-button
              i="fas fa-arrow-alt-circle-right"
              text="Continuar"
              variant="success pl-3 pr-3"
              @click="onContinue"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from '@/components/common/CustomCallout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import proposalStatus from '@/utils/shared/constants/proposalStatus';

export default {
  name: 'StatusTransition',
  components: {
    IconView,
    ActionButton,
    CustomInput,
    CustomDropDown,
    CustomCallout,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    model: {
      status: null,
      comment: null,
      poNumber: null,
      poBalance: null,
    },
  }),
  computed: {
    isDeliveredForObligation() {
      return this.model.status?.id == proposalStatus.DeliveredForObligation;
    },
  },
  mounted() {
    if (this.statuses.length == 1) {
      this.model.status = this.statuses[0];
      this.onStatusChange();
    }
  },
  methods: {
    onStatusChange() {
      const { name } = this.model.status;
      this.model.comment = `La propuesta ha sido cambiada al estatus ${name}`;
    },
    onClose() {
      this.$emit('on-close');
    },
    async onContinue() {
      const isValid = await this.$refs.statusCardObserver.validate();
      if (!isValid) return;

      let confirmation = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea cambiar a estatus <b>${this.model.status.name}</b>?`,
        'Si',
        'No'
      );

      if (!confirmation) return;

      this.$emit('on-continue', this.model);
    },
  },
};
</script>

<style scoped>
.actions-container {
  padding-top: 2rem;
}
</style>
